const rdp = {
  name: '',
  enabled: true,
  asset: '',
  protocol: 'rdp',
  record_session: false,
  settings: {
    port: 3389,
    domain: undefined,
    username: undefined,
    password: undefined,
    security: undefined,
    'disable-auth': undefined,
    'ignore-cert': true,
    console: undefined,
    'gateway-hostname': undefined,
    'gateway-port': undefined,
    'gateway-username': undefined,
    'gateway-password': undefined,
    'gateway-domain': undefined,
    'initial-program': undefined,
    'client-name': undefined,
    'server-layout': undefined,
    timezone: undefined,
    'color-depth': undefined,
    width: undefined,
    height: undefined,
    dpi: undefined,
    'resize-method': 'display-update',
    'console-audio': undefined,
    'disable-audio': undefined,
    'enable-audio-input': undefined,
    'enable-printing': undefined,
    'printer-name': undefined,
    'disable-copy': undefined,
    'disable-paste': undefined,
    'enable-wallpaper': undefined,
    'enable-theming': undefined,
    'enable-font-smoothing': undefined,
    'enable-full-window-drag': undefined,
    'enable-desktop-composition': undefined,
    'enable-menu-animations': undefined,
    'disable-bitmap-caching': undefined,
    'disable-offscreen-caching': undefined,
    'disable-glyph-caching': undefined,
    'remote-app': undefined,
    'remote-app-dir': undefined,
    'remote-app-args': undefined,
    'preconnection-id': undefined,
    'preconnection-blob': undefined,
    'recording-exclude-output': undefined,
    'recording-exclude-mouse': undefined,
    'recording-include-keys': undefined,
  },
  settings_meta: {
    secrets: {
      password: false,
    },
  },
};
const web = {
  name: '',
  enabled: true,
  asset: '',
  protocol: 'web',
  record_session: false,
  settings: {
    url: '',
    limit_network: false,
    hosts: '',
    'disable-copy': undefined,
    'disable-paste': undefined,
  },
  settings_meta: {
    secrets: {},
  },
};

const vnc = {
  name: '',
  enabled: true,
  asset: '',
  protocol: 'vnc',
  record_session: false,
  settings: {
    port: undefined,
    username: undefined,
    password: undefined,
    cursor: undefined,
    'color-depth': undefined,
    'read-only': undefined,
    'swap-red-blue': undefined,
    'enable-audio': undefined,
    'audio-servername': undefined,
    'clipboard-encoding': undefined,
    'disable-copy': undefined,
    'disable-paste': undefined,
    'recording-exclude-output': undefined,
    'recording-exclude-mouse': undefined,
    'recording-include-keys': undefined,
  },
  settings_meta: {
    secrets: {
      password: false,
    },
  },
};

const ssh = {
  name: '',
  enabled: true,
  asset: '',
  protocol: 'ssh',
  record_session: false,
  settings: {
    port: undefined,
    'host-key': undefined,
    username: undefined,
    password: undefined,
    private_key: undefined,
    passphrase: undefined,
    color_scheme: undefined,
    'disable-copy': undefined,
    'disable-paste': undefined,
    backspace: undefined,
    'recording-exclude-output': undefined,
    'recording-exclude-mouse': undefined,
    'recording-include-keys': undefined,
  },
  settings_meta: {
    secrets: {
      password: false,
      private_key: false,
      passphrase: false,
    },
  },
};

const emptyProfiles = {
  rdp,
  vnc,
  ssh,
  web,
};

export default emptyProfiles;
